import React from 'react';
import { Navigate } from 'react-router-dom';

const ConditionalNavigate = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    return <Navigate to={isLoggedIn ? "/submissions" : "/login"} />;
};

export default ConditionalNavigate;